// Account ▸ Art tab (route /clients/:id/library). Was a "coming soon"
// placeholder; now the account's art (Stephanie + reps, Jake go 2026-11-02):
//   1. This client's art — the live art library (client_brand_assets), the
//      same files the client sees in the portal's Brand Assets page.
//   2. From commonsku — the account's old commonsku artwork, client files and
//      proofs (CS Import archive), each with "Add to this client's art".
//      A sub-account with no commonsku art of its own shows its main
//      account's.
import { useOutletContext } from "react-router-dom";
import type { ClientDetailContext } from "@/pages/ClientDetailPage";
import { ClientArtLibrary, CommonskuArtList } from "@/components/artwork/CommonskuArt";

export function ClientLibraryTab() {
  const { clientId } = useOutletContext<ClientDetailContext>();
  return (
    <div className="space-y-12">
      <ClientArtLibrary clientId={clientId} />
      <CommonskuArtList clientId={clientId} />
    </div>
  );
}
